import React, { useState } from 'react';
import { Input, Label, Icon } from 'semantic-ui-react';

const GlobalFilter = ({
  globalFilter,
  setGlobalFilter,
}) => {
  const [value, setValue] = useState(globalFilter)
  const onChange = value => {
    setGlobalFilter(value || undefined)
  };

  return (
    <Input iconPosition='left' placeholder='Search Users by Name, Email or URL'>
      <Icon name='search' />
      <input
        style={{ width: 500 }} 
        value={value || ""}
        onChange={e => {
          setValue(e.target.value);
          onChange(e.target.value);
        }}
      />
    </Input>
  )
}

export default GlobalFilter;
